export default class Accordion {
  constructor() {
    this.activeClass = 'is-active';
    
    this.acdTrigger = document.querySelectorAll('.js-acd_trigger');

    this.focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), object, embed, [tabindex="0"], [contenteditable], iframe';
    if(this.acdTrigger.length > 0) {
      this.init();
    }
  }

  init() {
    this.ariaSet();
    this.acdToggle();
    this.openInitialDefaults();
    this.bindResize();
    this.bindContentResize();
  }

  ariaSet() {
    this.acdTrigger.forEach(el => {
      el.setAttribute('aria-expanded', 'false');
      let ariaControls = el.getAttribute('aria-controls');
      const target = document.querySelector('.js-acd_target[id="' + ariaControls + '"]');
      if(target) {
        target.setAttribute('aria-hidden', 'true');
        const acdFocusTarget = target.querySelectorAll(this.focusableElementsString);
        acdFocusTarget.forEach(e => {
          e.setAttribute("tabindex", -1);
        });
      }
    });
  }

  acdToggle() {
    this.acdTrigger.forEach(el => {
      const parent = el.closest('.js-acd_parent');
      if (!parent) {
        return;
      }
      const target = parent.querySelector('.js-acd_target');
      const classTarget = parent.querySelectorAll('.js-acd_class_target');
      if(target) {
        el.addEventListener('click', () => {
          if(el.classList.contains(this.activeClass)) {
            this.acdClose(el, target, classTarget);
          } else {
            this.acdOpen(el, target, classTarget);
          }
        });
      }
    });
  }

  // data-acd-default="open" のパネルを初期表示で開く
  openInitialDefaults() {
    document.querySelectorAll('.js-acd_parent[data-acd-default="open"]').forEach(parent => {
      const trigger = parent.querySelector('.js-acd_trigger');
      const target = parent.querySelector('.js-acd_target');
      const classTarget = parent.querySelectorAll('.js-acd_class_target');
      if (!trigger || !target) {
        return;
      }
      this.acdOpen(trigger, target, classTarget);
    });
    requestAnimationFrame(() => {
      this.syncOpenHeights();
    });
  }

  //パネルのmaxHeightを合わせ直す（リサイズ・初期レイアウトずれ対策）
  syncOpenHeights() {
    this.acdTrigger.forEach(el => {
      if (!el.classList.contains(this.activeClass)) {
        return;
      }
      const parent = el.closest('.js-acd_parent');
      if (!parent) {
        return;
      }
      const target = parent.querySelector('.js-acd_target');
      if (target) {
        target.style.maxHeight = `${target.scrollHeight}px`;
      }
    });
  }

  bindResize() {
    let ticking = false;
    window.addEventListener('resize', () => {
      if (ticking) {
        return;
      }
      ticking = true;
      requestAnimationFrame(() => {
        this.syncOpenHeights();
        ticking = false;
      });
    });
  }

  //アコーディオンを開いた後に中身の高さが変わった場合の再計算
  bindContentResize() {
    if (!('ResizeObserver' in window)) {
      return;
    }
  
    this.resizeObserver = new ResizeObserver(() => {
      this.syncOpenHeights();
    });
  
    document.querySelectorAll('.js-acd_target').forEach(target => {
      this.resizeObserver.observe(target);
    });
  }

  acdOpen(trigger, target, classTarget) {
    trigger.classList.add(this.activeClass);
    target.style.maxHeight = target.scrollHeight + 'px';
    trigger.setAttribute('aria-expanded', 'true');
    target.setAttribute('aria-hidden', 'false');
    classTarget.forEach(el => {
      el.classList.add(this.activeClass);
    });

    const acdFocusTarget = target.querySelectorAll(this.focusableElementsString);
    acdFocusTarget.forEach(el => {
      el.setAttribute("tabindex", 0);
    });
  }

  acdClose(trigger, target, classTarget) {
    trigger.classList.remove(this.activeClass);
    target.style.maxHeight = 0;
    trigger.setAttribute('aria-expanded', 'false');
    target.setAttribute('aria-hidden', 'true');
    classTarget.forEach(el => {
      el.classList.remove(this.activeClass);
    });

    const acdFocusTarget = target.querySelectorAll(this.focusableElementsString);
    acdFocusTarget.forEach(el => {
      el.setAttribute("tabindex", -1);
    });
  }

  
}